import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./global.scss";
import { mainAdminRouter } from "routers/main.admin";
import { mainUserRouter } from "routers/main.user";
import { authUserRouter } from "routers/auth.user";
import { authAdminRouter } from "routers/auth.admin";
import { useAppSelector } from "store/hooks";
import { useEffect } from "react";
import { useLazyGetUserQuery } from "@RTKQuery/user/auth/auth";
import { PreLoader } from "layout";
import { useLazyGetAdminQuery } from "@RTKQuery/admin/auth/auth";

export default function App() {
  const role: string = process.env.NODE_ENV === "production" ? window.location.origin.includes("panel") ? "admin" : "user" : window.location.pathname.includes("admin") ? "admin" : "user"

  const [getUser, userStatus] = useLazyGetUserQuery();
  const [getAdmin, adminStatus] = useLazyGetAdminQuery();

  const { isAuthAdmin, isAuthUser } = useAppSelector(state => state.global);

  useEffect(() => {
    if (role === "admin") {
      if (adminStatus.isUninitialized) {
        getAdmin()
      }
    } else {
      if (userStatus.isUninitialized) {
        getUser()
      }
    }
  }, [userStatus.isUninitialized, adminStatus.isUninitialized]);

  if ((userStatus.isUninitialized && adminStatus.isUninitialized) || userStatus.isFetching || adminStatus.isFetching) {
    return <PreLoader />
  } else {
    if (role === "admin") {
      if (isAuthAdmin) {
        return <RouterProvider router={createBrowserRouter(mainAdminRouter)} />;
      } else {
        return <RouterProvider router={createBrowserRouter(authAdminRouter)} />;
      }
    } else {
      if (isAuthUser) {
        return <RouterProvider router={createBrowserRouter(mainUserRouter)} />;
      } else {
        return <RouterProvider router={createBrowserRouter(authUserRouter)} />;
      }
    }
  }
}